<template>
  <div>
    <xg-header></xg-header>
    <router-view></router-view>
  </div>
</template>

<script>
import XgHeader from '@/components/common/header';

export default {
  name: 'pure-layout',
  components: {
    XgHeader,
  },
};
</script>
